import { Phone, MessageCircle } from "lucide-react";

export const SUPPORT_PHONE = "+91 97714 57007";
const DIGITS = "919771457007";

export function SupportContact({ compact = false, tid = "support" }) {
  return (
    <div className={`support-contact ${compact ? "compact" : ""}`} data-testid={tid}>
      <span>Sales &amp; support</span>
      <div>
        <a href={`tel:+${DIGITS}`} data-testid={`${tid}-call`}><Phone size={13} /> {compact ? "Call" : `Call ${SUPPORT_PHONE}`}</a>
        <a href={`https://wa.me/${DIGITS}?text=${encodeURIComponent("Hi FynDine team, I need help with")}`} target="_blank" rel="noreferrer" data-testid={`${tid}-whatsapp`}><MessageCircle size={13} /> WhatsApp</a>
      </div>
    </div>
  );
}
